import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Dialogue extends Vue {
    public title: string = 'Dialogue';

    @Prop({ default: false })
    public show: any;

    public showInternal = false;

    @Prop({ default: false })
    public showCancelButton: any;

    @Prop({ default: '80vw' })
    public width: any;

    @Prop({
        default: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
     Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
      when an unknown printer took a galley of type and scrambled it to make a type specimen book. ` })
    public data: any;
    @Prop({
        default: () => () => { }
    })
    public onOK: any;
    @Prop({
        default: () => () => { }
    })
    public onCancel: any;

    @Watch('show', { immediate: true, deep: true })
    public onShowChange(val: any, oldVal: any) {
        this.showInternal = val;
    }

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public clickOutside() {
        // this.showInternal = false;
    }
}
